module.exports = __webpack_public_path__ + "static/media/photo_013.d26c4b41.JPG";